import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=d45161f4"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=d45161f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports